import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { ProductGroupResource } from "@exonn/js-sdk";

export const module: Module<ProductGroupResource> = {
  id: ResourceEnum.ProductGroup,
  bigIcon: <i className="icon-20-groups_gds" />,
  smallIcon: <i className="icon-15-groups_gds" />,
  name: (t: TFunction) => t("moduleName.product-group"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
